import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  if (localStorage.getItem('cografa:token')) return true;
  return inject(Router).createUrlTree(['/sign-in']);
};

export const guestGuard: CanActivateFn = () => {
  if (!localStorage.getItem('cografa:token')) return true;
  return inject(Router).createUrlTree(['/inicio']);
};
